  (function() {
    'use strict';

// --- i18n mapping für Klaviyo-Fehler (de) ---
function translateKlaviyoError(err) {
  if (!err) return null;
  var code   = err.code   || '';
  var title  = err.title  || '';
  var detail = err.detail || '';

  // Bekannte Titel/Details
  var known = {
    'Invalid email address': 'Ungültige E-Mail-Adresse',
    'Email is already subscribed to back in stock': 'Diese E-Mail-Adresse ist bereits für Benachrichtigungen eingetragen.',
    'Duplicate back in stock subscription': 'Diese E-Mail-Adresse ist bereits für Benachrichtigungen eingetragen.',
    'Profile is suppressed': 'Diese E-Mail-Adresse kann keine Nachrichten empfangen.',
    'Variant not found': 'Variante nicht gefunden.'
  };
  if (known[title])  return known[title];
  if (known[detail]) return known[detail];

  // Fallbacks nach Fehlercode
  switch (code) {
    case 'invalid':
      if (err.source && /email/i.test(JSON.stringify(err.source))) return 'Ungültige E-Mail-Adresse';
      return 'Ungültige Eingabe';
    case 'conflict':
      return 'Diese E-Mail-Adresse ist bereits für Benachrichtigungen eingetragen.';
    case 'not-found':
      return 'Variante nicht gefunden.';
    case 'forbidden':
    case 'unauthorized':
      return 'Nicht berechtigt.';
    default:
      return null; // Unknown -> keine englischen Titel/Details anzeigen
  }
}

    function parseVariantData() {
      var map = {};
      try {
        var el = document.querySelector('script[data-variant-products]');
        if (el) {
          var json = JSON.parse(el.textContent);
          if (json && json.product && Array.isArray(json.product.variants)) {
            json.product.variants.forEach(function(v){
              map[String(v.id)] = { available: !!v.available, title: v.title || '' };
            });
            return map;
          }
        }
      } catch(e) {}

      try {
        if (window.shopifyProduct && Array.isArray(window.shopifyProduct.variants)) {
          window.shopifyProduct.variants.forEach(function(v){
            map[String(v.id)] = { available: !!v.available, title: v.title || '' };
          });
        }
      } catch(e) {}
      return map;
    }

    function getVariantInput(scope) {
      // Prefer the variant id input within the same product info area
      var info = scope.closest('.product-info') || document;
      return info.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }

    function KlaviyoBIS(root) {
      this.root = root;
      this.form = root.querySelector('.klaviyo-bis-form');
      this.email = this.form && this.form.querySelector('input[name="email"]');
      this.variantHidden = this.form && this.form.querySelector('input[name="variant_id"]');
      this.statusEl = root.querySelector('.klaviyo-bis-status');
      this.submitBtn = this.form && this.form.querySelector('button[type="submit"]');
      this.siteId = root.getAttribute('data-site-id');
      this.variantInput = getVariantInput(root);
      this.availability = parseVariantData();
      this.variantTitleEl = root.querySelector('.klaviyo-bis-variant-title');
    }

    KlaviyoBIS.prototype.sync = function() {
      if (!this.variantInput) return;
      var vid = this.variantInput.value;
      if (this.variantHidden) this.variantHidden.value = vid || '';

      var vData = this.availability.hasOwnProperty(String(vid)) ? this.availability[String(vid)] : null;
      var isAvail = vData && typeof vData.available !== 'undefined' ? !!vData.available : true;

      // Show only when out of stock
      this.root.hidden = !!isAvail || !vid;

      // Update the inline message with the current variant title
      if (this.variantTitleEl) {
        var title = vData && vData.title ? vData.title : '';
        if (!title) {
          // Fallback: try to read from a select[name="id"] option
          var form = this.variantInput.closest('form');
          var opt = form && form.querySelector('select[name="id"] option:checked');
          if (opt && opt.text) title = opt.text;
        }
        if (title) this.variantTitleEl.textContent = title;
      }
    };

    KlaviyoBIS.prototype.attachVariantListeners = function() {
      var self = this;
      if (!this.variantInput) return;
      // Direct change listener
      this.variantInput.addEventListener('change', function(){ self.sync(); });
      // Some themes update the value programmatically — observe attribute changes
      var obs = new MutationObserver(function(){ self.sync(); });
      obs.observe(this.variantInput, { attributes: true, attributeFilter: ['value'] });
      // And listen on the surrounding product form for broader changes
      var form = self.variantInput.closest('form');
      if (form) form.addEventListener('change', function(){ self.sync(); });
      this._observer = obs;
      this.sync();
    };

    KlaviyoBIS.prototype.submit = function(e) {
      e.preventDefault();
      if (!this.form || !this.email || !this.variantHidden || !this.siteId) return;

      var email = (this.email.value || '').trim();
      if (!email || (this.email && !this.email.checkValidity())) {
        this.setStatus('Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
        if (this.email && this.email.reportValidity) { this.email.reportValidity(); }
        return;
      }

      var variantId = (this.variantHidden.value || '').trim();
      if (!variantId) {
        this.setStatus('Bitte wähle zuerst eine Variante.', 'error');
        return;
      }

      var endpoint = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.siteId);
      var headers = {
        'accept': 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        'revision': '2025-04-15'
      };
      var catalogVariantId = '$shopify:::$default:::' + variantId;
      var body = JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { variant: { data: { type: 'catalog-variant', id: catalogVariantId } } }
        }
      });

      this.toggleSubmitting(true);
      var self = this;
      self._submittedOk = false;
      fetch(endpoint, { method: 'POST', headers: headers, body: body })
        .then(function(res){
          if (res.ok) return { ok: true };
          return res.json().catch(function(){return {}}).then(function(j){ return { ok:false, status: res.status, body: j }; });
        })
        .then(function(result){
          if (result.ok) {
            if (self.email) self.email.value = '';
            self.setStatus('Danke! Wir benachrichtigen dich, sobald der Artikel wieder verfügbar ist.', 'success');
            self._submittedOk = true; // Flag für finally
            if (self.submitBtn) { self.submitBtn.disabled = true; self.submitBtn.setAttribute('aria-disabled','true'); }
            if (self.form) self.form.classList.remove('is-submitting');
          } else {
            var errObj  = result && result.body && result.body.errors && result.body.errors[0];
            var deDetail = translateKlaviyoError(errObj);
            var suffix  = deDetail ? ' (' + deDetail + ')' : '';
            self.setStatus('Das hat leider nicht geklappt.' + suffix + ' Bitte versuche es erneut.', 'error');
          }
        })
        .catch(function(){ self.setStatus('Netzwerkfehler – bitte versuche es später erneut.', 'error'); })
        .finally(function() {
          if (!self._submittedOk) self.toggleSubmitting(false);
          if (self.form) self.form.classList.remove('is-submitting');
        });
    };

    KlaviyoBIS.prototype.setStatus = function(text, kind) {
      if (!this.statusEl) return;
      this.statusEl.className = 'klaviyo-bis-status' + (kind ? ' ' + kind : '');
      this.statusEl.textContent = text || '';
    };

    KlaviyoBIS.prototype.toggleSubmitting = function(isSubmitting) {
      if (this.submitBtn) this.submitBtn.disabled = !!isSubmitting;
      if (this.form) this.form.classList.toggle('is-submitting', !!isSubmitting);
    };

    KlaviyoBIS.prototype.init = function() {
      if (!this.form) return;
      this.attachVariantListeners();
      this.form.addEventListener('submit', this.submit.bind(this));
    };

    onReady(function(){
      document.querySelectorAll('.klaviyo-bis-inline').forEach(function(el){
        try { new KlaviyoBIS(el).init(); } catch(e) { /* no-op */ }
      });
    });
  })();